import * as types from "./actionTypes";
import axios from "axios";

export const getRubric = rubricId => dispatch => {
  axios
    .get(process.env.REACT_APP_API_URL + "/articles/" + rubricId)
    .then(({ data }) => {
      return dispatch({
        type: types.RUBRIC_GET,
        data
      });
    });
};

export const clearRubric = () => dispatch => {
  return dispatch({
    type: types.RUBRIC_CLEAR
  });
};



// WEBPACK FOOTER //
// ./src/modules/rubric/actions.js